var map = {
	"./bo.svg": "6ac2",
	"./bp.svg": "e323",
	"./breath.svg": "e3de",
	"./bt.svg": "dff0",
	"./conscious.svg": "1d61",
	"./dietary.svg": "324c",
	"./emotional.svg": "fac0",
	"./glucose.svg": "ea8f",
	"./height.svg": "2c98",
	"./weight.svg": "5280"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a601";